"use strict";

/**
 * @module indicative-rules
 */
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const indicative_utils_1 = require("indicative-utils");
const pluralize = __importStar(require("pluralize"));
/**
 * Converts a value to it's singular version. If value is not a string
 * then it will be returned as it is.
 *
 * ```ts
 * import { sanitizations } from 'indicative/sanitizer'
 *
 * const sanitizationRules = {
 *   modelName: 'singular'
 * }
 *
 * // or
 * const sanitizationRules = {
 *   modelName: [
 *     sanitizations.singular()
 *   ]
 * }
 * ```
 */
const singular = {
  sanitize(data, field) {
    let fieldValue = indicative_utils_1.getValue(data, field);
    if (typeof fieldValue !== 'string') {
      return;
    }
    indicative_utils_1.patchValue(data, field, pluralize.singular(fieldValue));
  }
};
exports.default = singular;